import React from "react";
import { NavLink, Link } from "react-router-dom";

/**
 * @author
 * @function MenuItem
 **/

const MenuItem = (props) => {
    //const { name, subMenus, iconClassName, onClick, to, exact } = props;
    const { name, subMenus, iconClassName, to } = props;
    //const [expand, setExpand] = useState(false);

    return (
        <li onClick={props.onClick}>
            <Link exact="true" to={to} className={`menu-item`}>
                <div className="menu-icon">
                    <i className={iconClassName}></i>
                </div>
                <span>{name}</span>
            </Link>
            {subMenus && subMenus.length > 0 ? (
                <ul className={`sub-menu`}>
                    {subMenus.map((menu, index) => (
                        <li key={index}>
                            <NavLink to={menu.to}>
                                <div className="menu-icon">
                                    <i className={menu.iconClassName}></i>
                                </div>
                                <span>{menu.name}</span>
                            </NavLink>
                        </li>
                    ))}
                </ul>
            ) : null}
        </li>
    );
};

export default MenuItem;
